import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_COURSEOUTLINE,
  GET_COURSEOUTLINES,
  GET_COURSEOUTLINES_BY_FILTER,
  GET_COURSEOUTLINEUNITS_BY_COURSEOUTLINEID,
  GET_COURSEOUTLINES_BY_FILTER_FOR_TABLE,
  GET_COURSEOUTLINES_AVAILABLE,
  ADD_COURSEOUTLINE,
  UPDATE_COURSEOUTLINE,
  DELETE_COURSEOUTLINE,
  GET_COURSEOUTLINES_PAGINATION,
  GET_COURSEOUTLINES_NOT_OPEN_PAGINATION,
  GET_COURSEOUTLINES_BY_CODE_OR_NAME,
} from '@/queries/modules/courses/course-outline.js';

export async function getCourseOutlines(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINES,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.courseOutline;
    } else {
      context.commit('setCourseOutlines', data.getCourseOutlines);
      context.commit('setSuccess', null);
      return data.getCourseOutlines
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getCourseOutlinesByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINES_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setCourseOutlines', data.getCourseOutlinesByFilter);
      context.commit('setSuccess', null);

      return data.getCourseOutlinesByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getCourseOutlineUnitsByCourseOutlineId(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINEUNITS_BY_COURSEOUTLINEID,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setCourseOutlines', data.getCourseOutlineUnitsByCourseOutlineId);
      context.commit('setSuccess', null);

      return data.getCourseOutlineUnitsByCourseOutlineId;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getCourseOutlinesByFilterForTable(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINES_BY_FILTER_FOR_TABLE,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setCourseOutlines', data.getCourseOutlinesByFilter);
      context.commit('setSuccess', null);

      return data.getCourseOutlinesByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getCourseOutlinesAvailable(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINES_AVAILABLE,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setCourseOutlines', data.getCourseOutlinesAvailable);
      context.commit('setSuccess', null);

      return data.getCourseOutlinesAvailable;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getCourseOutline(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINE,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.courseOutline;
    } else {
      context.commit('setCourseOutline', data.getCourseOutline);
      context.commit('setSuccess', null);
      return data.getCourseOutline
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getCourseOutlinesPagination(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINES_PAGINATION,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.courseOutlinesPagination;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}
export async function getCourseOutlinesNotOpenPagination(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINES_NOT_OPEN_PAGINATION,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.courseOutlinesNotOpenPagination;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}
/**
 *  Action to Add Course Outline
 *
 *   @param  {Object} context Vuex context object.
 *     @property {Vuex method (Function)} commit : "To commit a mutation"
 *
 *   @param  {Object} payload Contain requires inputs for adding data
 *     @property {CourseOutlineInput (Array), required} courseOutlineInput : [{
          academicPeriodId: "", // {String} Get it from filter selection.
          periodCode: "",       // {String} Get it from filter selection.
          degreeId: "",         // {String} Get it from filter selection.
          subjectGroupId: "",   // {String} Get it from filter selection.
          subjectId: "",        // {String} Get it from Course Outline Selection.
          subjectCode: "",      // {String} "----------------------------------"
          subjectName: "",      // {String} "----------------------------------"
          courseOutlineId: "",  // {String} "----------------------------------"
          teacherId: "",        // {String} "----------------------------------"
          teacherCode: "",      // {String} "----------------------------------"
        }]
 *   @param  {Boolean} useState boolean if true method will set state will return data, Default: true
 *
 */
export async function addCourseOutline(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_COURSEOUTLINE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const courseOutlines = [...context.state.courseOutlines];
      courseOutlines.push(data.addCourseOutline);
      context.commit('setCourseOutlines', courseOutlines);
      context.commit('setSuccess', newItemSuccess(data.addCourseOutline.subject.code));

      return data.addCourseOutline
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateCourseOutline(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_COURSEOUTLINE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.courseOutlines.findIndex(item => item.id === data.updateCourseOutline.id);
      const courseOutlines = [
        ...context.state.courseOutlines.slice(0, index),
        data.updateCourseOutline,
        ...context.state.courseOutlines.slice(index + 1)
      ];
      context.commit('setCourseOutlines', courseOutlines);
      context.commit('setSuccess', updateItemSuccess(data.updateCourseOutline.subject.code));

      return data.updateCourseOutline
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

/**
 *  Action to Delete Course Outline
 *
 *   @param  {Object} context Vuex context object.
 *     @property {Vuex method (Function)} commit : "To commit a mutation"
 *
 *   @param  {Object} payload Contain requires inputs for adding data
 *     @property {ID (String), required} id : "ID of a Course Outline "
 *
 */
export async function deleteCourseOutline(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_COURSEOUTLINE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.courseOutlines.findIndex(item => item.id === data.deleteCourseOutline.id);
      const courseOutlines = [
        ...context.state.courseOutlines.slice(0, index),
        ...context.state.courseOutlines.slice(index + 1)
      ];
      context.commit('setCourseOutlines', courseOutlines);
      context.commit('setSuccess', deleteItemSuccess(data.deleteCourseOutline.subject.code));

      return data.deleteCourseOutline
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

// The borrow-video picker's course-outline type-ahead. Deliberately does NOT
// commit setProcessing: it fires on every keystroke behind an open dialog,
// and the shared processing state drives the full-screen Loader -- the same
// abstention, for the same reason, as getReusableVdoSetTopics in the
// vdo-set-topic module. Errors return [] rather than notifying: this is a
// sidecar fetch for a dialog's own dropdown, not a user-initiated action.
export async function getCourseOutlinesByCodeOrName(context, payload) {
  try {
    const {data, errors} = await apolloClient.query({
      query: GET_COURSEOUTLINES_BY_CODE_OR_NAME,
      variables: payload,
      fetchPolicy: 'network-only',
    });

    if (errors) {
      console.error(errors); // eslint-disable-line no-console
      return [];
    }
    return data.getCourseOutlinesByCodeOrName || [];
  } catch (e) {
    console.error(e); // eslint-disable-line no-console
    return [];
  }
}

